import { deepMerge } from '../../modules/deep_merge.js';
import { alternateHighchartsLegendClick } from './highcharts_custom.js';

window.Visualizations.Highcharts.Base = {
  resolveEnableContextMenu: function (rubyOpts) {
    if (rubyOpts.enable_context_menu !== undefined) {
      return rubyOpts.enable_context_menu === true;
    }

    return globalThis.__highchartsEnableContextMenu === true;
  },

  contextMenuOptions: function (enableContextMenu) {
    if (enableContextMenu) {
      return {};
    }

    return {
      exporting: {
        buttons: {
          contextButton: {
            enabled: false
          }
        }
      },
      chart: {
        events: {
          contextmenu: function (e) {
            e.preventDefault();
          }
        }
      }
    };
  },

  withDefaultOptions: function (rubyOpts, jsOpts) {
    var formatter = function () {
      var tipColor = this.color;
      var seriesText = this.series.name;
      var xval = this.x;
      var value = this.y;

      var tooltipOpts = rubyOpts.tooltip;

      var formattedNumber = Highcharts.numberFormat(value, 0, '.', ',');
      if (value % 1 != 0) formattedNumber = Highcharts.numberFormat(value, 2, '.', ',');
      
      var stackTotalText = '';

      var tooltipPrefix = '';
      var tooltipSuffix = '';
      var tooltipFooter = '';

      if (tooltipOpts) {
        tooltipPrefix = tooltipOpts.prefix || '';
        tooltipSuffix = tooltipOpts.suffix || '';
        tooltipFooter = tooltipOpts.footer || '';
      }

      if (jsOpts.showStackTotal) {
        var stackTotal = Highcharts.numberFormat(this.point.stackTotal, 2, '.', ',');

        stackTotalText = "<div style=\"margin-top: 4px; background-color: white; font-weight: bold; font-size: 12px;\">Total<br>" + tooltipPrefix + stackTotal + tooltipSuffix + "</div>";
      }

      if (jsOpts.chart.type === 'pie') {
        xval = seriesText;
        seriesText = this.key;
      }

      if (['column', 'bar'].includes(jsOpts.chart.type)) {
        xval = rubyOpts['categories'][xval];
      }

      return '<div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);"><div style="background-color: white; padding: 10px; border-top: 8px solid ' + tipColor + '">' + '<b>' + xval + '</b><div>' + seriesText + '</div></div><div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;"><div  style="font-weight: bold; color: ' + tipColor + '">' + tooltipPrefix + formattedNumber + tooltipSuffix + '</div>' + stackTotalText + tooltipFooter + '</div></div>'
    };

    var defaultOptions = {
      chart: {
        backgroundColor: '#ffffff',
        plotBackgroundColor: '#ffffff'
      },
      accessibility: {
        enabled: false
      },
      title: {
        text: rubyOpts.title,
        align: 'center',
        style: { color: '#a11d20', fontSize: '22px', marginTop: '20px', marginBottom: '10px' }
      },
      plotOptions: {
        series: {
          events: {
            legendItemClick: alternateHighchartsLegendClick
          }
        }
      },
      credits: {
        enabled: true,
        text: rubyOpts.credits,
        href: '',
        style: { cursor: 'default' }
      },
      tooltip: {
        useHTML: true,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        formatter: formatter
      },
      colors: rubyOpts.colors,
      legend: {
        layout: 'vertical',
        align: 'right',
        enabled: true,
        verticalAlign: 'top',
        itemMarginTop: 1,
        itemMarginBottom: 4,
        itemStyle: { fontSize: 14, lineHeight: 14, fontWeight: 'Light' },
        symbolHeight: 14,
        symbolWidth: 14,
        symbolRadius: 0,
        reversed: false,
        permanentlyDisable: false,
        maxHeight: 270
      }
    };

    return deepMerge(defaultOptions, this.contextMenuOptions(this.resolveEnableContextMenu(rubyOpts)), jsOpts);
  },
  renderChart: function(htmlID, rubyOpts, jsOpts) {
    if (jsOpts['chart']['type'] === 'map') {
      var chart = Highcharts.mapChart(htmlID, this.withDefaultOptions(rubyOpts, jsOpts));

      return chart;
    }
    var chart = Highcharts.chart(htmlID, this.withDefaultOptions(rubyOpts, jsOpts));

    return chart;
  },

  wireAccordionChart: function (htmlID, renderFn) {
    var container = document.getElementById(htmlID);
    if (!container) return;

    var collapsePanel = container.closest('.accordion-body.collapse');
    if (!collapsePanel) {
      renderFn();
      return;
    }

    var chart;
    var ensureChart = function () {
      if (!chart) {
        chart = renderFn();
      } else {
        chart.reflow();
      }
    };

    if (collapsePanel.classList.contains('show')) {
      ensureChart();
    }

    collapsePanel.addEventListener('shown.bs.collapse', ensureChart);
  }
};
